/* eslint-disable quotes */
import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import Logo from "../assets/img/logocucv1.png";
import { MdOutlineCancel } from "react-icons/md";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";
import {
  FiUser,
  FiCheck,
  FiUsers,
  FiMenu,
  FiList,
  FiLogOut,
  FiActivity,
  FiMove,
  FiTarget,
  FiAward,
  FiBook,
  FiClipboard,
  FiCalendar,
  FiInfo,
  FiBarChart,
  FiChevronDown,
  FiSearch,
} from "react-icons/fi";

// Componentes de Material-UI v4
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

import { useStateContext } from "../contexts/ContextProvider";
import { connect } from "react-redux";
import { logoutRequest } from "../actions/index";

const useStyles = makeStyles({
  root: {
    margin: "0 !important", // Quita el margin predeterminado
    padding: "0 !important", // Quita el padding predeterminado
    boxShadow: "none", // Quita la sombra por defecto de MUI
    backgroundColor: "transparent", // Fondo transparente
    "&.MuiAccordion-root:before": {
      content: "none", // Quita la línea de separación
    },
    "& .MuiIconButton-root": {
      padding: "0", // Quita el padding del ícono de expansión
    },
    "& .MuiAccordionSummary-root": {
      minHeight: "40px", // Ajusta la altura mínima
      padding: "0 16px 0 0", // Ajusta el padding
    },
    // Estilos para el content dentro del summary
    "& .MuiAccordionSummary-content": {
      margin: "0", // Elimina el margin en el contenido
    },
  },
  details: {
    display: "flex",
    flexDirection: "column",
    padding: "0 0 0 16px", // Añade un padding a la izquierda para indentar los enlaces
  },
});

const Sidebar = (props) => {
  const classes = useStyles();
  const { currentColor, activeMenu, setActiveMenu, screenSize } =
    useStateContext();
  const { logoutRequest, permission } = props;
  // Estado para controlar la apertura del acordeón
  const [expanded, setExpanded] = useState(false);

  const handleCloseSideBar = () => {
    if (activeMenu !== undefined && screenSize <= 900) {
      setActiveMenu(false);
    }
  };

  // Función para manejar el cambio de estado del acordeón
  const handleChange = () => {
    setExpanded(!expanded);
  };

  const activeLink =
    "flex items-center gap-5 pl-4 pt-3 pb-2.5 rounded-lg  text-white text-md m-2";
  const normalLink =
    "flex items-center gap-5 pl-4 pt-3 pb-2.5 rounded-lg text-md text-gray-700 dark:text-gray-200 dark:hover:text-black hover:bg-light-gray m-2";

  // Estilo para los subenlaces dentro del acordeón (un poco indentados)
  const subLinkStyle =
    "flex items-center gap-5 pl-8 pt-2 pb-2 rounded-lg text-md text-gray-700 hover:bg-light-gray m-2";
  const activeSubLinkStyle =
    "flex items-center gap-5 pl-8 pt-2 pb-2 rounded-lg text-gray-700 text-md m-2 text-white hover:text-white";

  return (
    <div className="h-screen pb-10 ml-3 overflow-auto md:overflow-hidden md:hover:overflow-auto">
      {activeMenu && (
        <>
          <div className="flex items-center justify-between">
            <Link
              to="/"
              onClick={handleCloseSideBar}
              className="flex items-center gap-3 mt-4 ml-3 text-xl font-extrabold tracking-tight dark:text-white text-slate-900"
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img src={Logo} style={{ maxWidth: "56%" }} />
              </div>
            </Link>
            <TooltipComponent content="Menu" position="BottomCenter">
              <button
                type="button"
                onClick={() => setActiveMenu(!activeMenu)}
                style={{ color: currentColor }}
                className="block p-3 mt-4 text-xl rounded-full hover:bg-light-gray md:hidden"
              >
                <MdOutlineCancel />
              </button>
            </TooltipComponent>
          </div>
          {(permission.includes(8) ||
            permission.includes(9) ||
            permission.includes(10) ||
            permission.includes(11) ||
            permission.includes(12) ||
            permission.includes(13) ||
            permission.includes(14) ||
            permission.includes(15) ||
            permission.includes(16) ||
            permission.includes(17)) && (
            <>
              <div className="mt-4 ">
                <p className="m-3 mt-4 text-gray-400 uppercase dark:text-gray-400">
                  Parametrización evaluación docente
                </p>
                {permission.includes(16) && (
                  <NavLink
                    to="/report"
                    onClick={handleCloseSideBar}
                    style={({ isActive }) => ({
                      backgroundColor: isActive ? currentColor : "",
                    })}
                    className={({ isActive }) =>
                      isActive ? activeLink : normalLink
                    }
                  >
                    <FiBarChart />
                    <span className="capitalize ">Reportes</span>
                  </NavLink>
                )}
                {permission.includes(8) && (
                  <NavLink
                    to="/skills"
                    onClick={handleCloseSideBar}
                    style={({ isActive }) => ({
                      backgroundColor: isActive ? currentColor : "",
                    })}
                    className={({ isActive }) =>
                      isActive ? activeLink : normalLink
                    }
                  >
                    <FiTarget />
                    <span className="capitalize ">Competencias</span>
                  </NavLink>
                )}
                {permission.includes(9) && (
                  <NavLink
                    to="/measurementScales"
                    onClick={handleCloseSideBar}
                    style={({ isActive }) => ({
                      backgroundColor: isActive ? currentColor : "",
                    })}
                    className={({ isActive }) =>
                      isActive ? activeLink : normalLink
                    }
                  >
                    <FiCheck />
                    <span className="capitalize ">Escalas de medición</span>
                  </NavLink>
                )}
                {permission.includes(10) && (
                  <NavLink
                    to="/departments"
                    onClick={handleCloseSideBar}
                    style={({ isActive }) => ({
                      backgroundColor: isActive ? currentColor : "",
                    })}
                    className={({ isActive }) =>
                      isActive ? activeLink : normalLink
                    }
                  >
                    <FiAward />
                    <span className="capitalize ">Departamentos</span>
                  </NavLink>
                )}
                {permission.includes(11) && (
                  <NavLink
                    to="/programs"
                    onClick={handleCloseSideBar}
                    style={({ isActive }) => ({
                      backgroundColor: isActive ? currentColor : "",
                    })}
                    className={({ isActive }) =>
                      isActive ? activeLink : normalLink
                    }
                  >
                    <FiBook />
                    <span className="capitalize ">Programas</span>
                  </NavLink>
                )}
                {permission.includes(12) && (
                  <NavLink
                    to="/grades"
                    onClick={handleCloseSideBar}
                    style={({ isActive }) => ({
                      backgroundColor: isActive ? currentColor : "",
                    })}
                    className={({ isActive }) =>
                      isActive ? activeLink : normalLink
                    }
                  >
                    <FiClipboard />
                    <span className="capitalize ">Materias</span>
                  </NavLink>
                )}
                {permission.includes(13) && (
                  <NavLink
                    to="/periods"
                    onClick={handleCloseSideBar}
                    style={({ isActive }) => ({
                      backgroundColor: isActive ? currentColor : "",
                    })}
                    className={({ isActive }) =>
                      isActive ? activeLink : normalLink
                    }
                  >
                    <FiCalendar />
                    <span className="capitalize ">Periodos</span>
                  </NavLink>
                )}
                {permission.includes(14) && (
                  <NavLink
                    to="/questions"
                    onClick={handleCloseSideBar}
                    style={({ isActive }) => ({
                      backgroundColor: isActive ? currentColor : "",
                    })}
                    className={({ isActive }) =>
                      isActive ? activeLink : normalLink
                    }
                  >
                    <FiInfo />
                    <span className="capitalize ">Preguntas</span>
                  </NavLink>
                )}
                {permission.includes(15) && (
                  <NavLink
                    to="/gradeGroups"
                    onClick={handleCloseSideBar}
                    style={({ isActive }) => ({
                      backgroundColor: isActive ? currentColor : "",
                    })}
                    className={({ isActive }) =>
                      isActive ? activeLink : normalLink
                    }
                  >
                    <FiUsers />
                    <span className="capitalize ">Grupos de materias</span>
                  </NavLink>
                )}
                {permission.includes(17) && (
                  <NavLink
                    to="/surveys"
                    onClick={handleCloseSideBar}
                    style={({ isActive }) => ({
                      backgroundColor: isActive ? currentColor : "",
                    })}
                    className={({ isActive }) =>
                      isActive ? activeLink : normalLink
                    }
                  >
                    <FiBarChart />
                    <span className="capitalize ">Encuestas</span>
                  </NavLink>
                )}

                {/* NUEVO ENLACE PARA CONSULTA EXTERNA */}
                <NavLink
                  to="/test-external"
                  onClick={handleCloseSideBar}
                  style={({ isActive }) => ({
                    backgroundColor: isActive ? currentColor : "",
                  })}
                  className={({ isActive }) =>
                    isActive ? activeLink : normalLink
                  }
                >
                  <FiSearch />
                  <span className="capitalize ">Consulta Externa</span>
                </NavLink>

              </div>
            </>
          )}
          {(permission.includes(1) ||
            permission.includes(2) ||
            permission.includes(3) ||
            permission.includes(4) ||
            permission.includes(5) ||
            permission.includes(6) ||
            permission.includes(7)) && (
            <>
              <div className="mt-10 ">
                <p className="m-3 mt-4 text-gray-400 uppercase dark:text-gray-400">
                  Configuración
                </p>
                {/* --- INICIO DEL ACORDEÓN --- */}
                {permission.includes(2) && (
                  <Accordion
                    expanded={expanded}
                    onChange={handleChange}
                    className={classes.root}
                  >
                    {/* RESUMEN/BOTÓN DEL ACORDEÓN (El título principal) */}
                    <AccordionSummary
                      // El ícono de flecha cambia dependiendo del estado `expanded`
                      expandIcon={
                        <FiChevronDown
                          style={{
                            color: expanded ? "#401118" : currentColor,
                            transform: expanded
                              ? "rotate(180deg)"
                              : "rotate(0deg)",
                            transition: "transform 0.3s",
                            paddingRight: "8px",
                          }}
                        />
                      }
                      aria-controls="users-content"
                      id="users-header"
                      style={{
                        // Aplicamos el estilo de enlace normal/activo al Summary
                        backgroundColor: expanded ? "#eeb4b3" : "",
                        borderRadius: "0.5rem",
                        padding: "0.75rem 1rem",
                      }}
                      // El estilo para el Summary debe replicar el activeLink/normalLink en su contenido
                      className={expanded ? activeLink : normalLink}
                    >
                      <div
                        style={{
                          color: expanded ? "#401118" : "inherit",
                        }}
                        className="flex items-center gap-5"
                      >
                        <FiUser />
                        <span className="capitalize">Usuarios</span>
                      </div>
                    </AccordionSummary>

                    {/* DETALLES DEL ACORDEÓN (Los subenlaces) */}
                    <AccordionDetails className={classes.details}>
                      {/* El primer NavLink (Asumiendo que es "Listar Usuarios") */}
                      <NavLink
                        to="/users"
                        end
                        onClick={handleCloseSideBar}
                        style={({ isActive }) => ({
                          backgroundColor: isActive ? currentColor : "",
                        })}
                        className={({ isActive }) =>
                          isActive ? activeSubLinkStyle : subLinkStyle
                        }
                      >
                        <span className="capitalize ">Listar Usuarios</span>
                      </NavLink>

                      {/* El segundo NavLink (Asumiendo que es "Crear Usuario" o similar) */}
                      <NavLink
                        to="/users/create" // Cambié el `to` para que sean rutas distintas
                        onClick={handleCloseSideBar}
                        style={({ isActive }) => ({
                          backgroundColor: isActive ? currentColor : "",
                        })}
                        className={({ isActive }) => {
                          return isActive ? activeSubLinkStyle : subLinkStyle;
                        }}
                      >
                        <span className="capitalize ">Crear Usuario</span>
                      </NavLink>

                      <NavLink
                        to="/users/detail" // Ruta para una página que te permita buscar el usuario por ID/nombre
                        onClick={handleCloseSideBar}
                        style={({ isActive }) => ({
                          backgroundColor: isActive ? currentColor : "",
                        })}
                        className={({ isActive }) =>
                          isActive ? activeSubLinkStyle : subLinkStyle
                        }
                      >
                        <span className="capitalize ">
                          Buscar y Ver Detalle
                        </span>
                      </NavLink>
                    </AccordionDetails>
                  </Accordion>
                )}
                {/* --- FIN DEL ACORDEÓN --- */}

                {permission.includes(5) && (
                  <NavLink
                    to="/permissions"
                    onClick={handleCloseSideBar}
                    style={({ isActive }) => ({
                      backgroundColor: isActive ? currentColor : "",
                    })}
                    className={({ isActive }) =>
                      isActive ? activeLink : normalLink
                    }
                  >
                    <FiCheck />
                    <span className="capitalize ">Permisos</span>
                  </NavLink>
                )}
                {permission.includes(1) && (
                  <NavLink
                    to="/userGroups"
                    onClick={handleCloseSideBar}
                    style={({ isActive }) => ({
                      backgroundColor: isActive ? currentColor : "",
                    })}
                    className={({ isActive }) =>
                      isActive ? activeLink : normalLink
                    }
                  >
                    <FiUsers />
                    <span className="capitalize ">Grupos de usuario</span>
                  </NavLink>
                )}
                {permission.includes(3) && (
                  <NavLink
                    to="/modules"
                    onClick={handleCloseSideBar}
                    style={({ isActive }) => ({
                      backgroundColor: isActive ? currentColor : "",
                    })}
                    className={({ isActive }) =>
                      isActive ? activeLink : normalLink
                    }
                  >
                    <FiMenu />
                    <span className="capitalize ">Módulos</span>
                  </NavLink>
                )}
                {permission.includes(6) && (
                  <NavLink
                    to="/parameters"
                    onClick={handleCloseSideBar}
                    style={({ isActive }) => ({
                      backgroundColor: isActive ? currentColor : "",
                    })}
                    className={({ isActive }) =>
                      isActive ? activeLink : normalLink
                    }
                  >
                    <FiList />
                    <span className="capitalize ">Parámetros</span>
                  </NavLink>
                )}
                {permission.includes(6) && (
                  <NavLink
                    to="/sessions"
                    onClick={handleCloseSideBar}
                    style={({ isActive }) => ({
                      backgroundColor: isActive ? currentColor : "",
                    })}
                    className={({ isActive }) =>
                      isActive ? activeLink : normalLink
                    }
                  >
                    <FiActivity />
                    <span className="capitalize ">Sesiones</span>
                  </NavLink>
                )}
                {permission.includes(4) && (
                  <NavLink
                    to="/actions"
                    onClick={handleCloseSideBar}
                    style={({ isActive }) => ({
                      backgroundColor: isActive ? currentColor : "",
                    })}
                    className={({ isActive }) =>
                      isActive ? activeLink : normalLink
                    }
                  >
                    <FiMove />
                    <span className="capitalize ">Acciones</span>
                  </NavLink>
                )}
              </div>
            </>
          )}
          <div className="mt-10 ">
            <p className="m-3 mt-4 text-gray-400 uppercase dark:text-gray-400">
              Sesión
            </p>
            <NavLink
              to="/"
              onClick={logoutRequest}
              style={({ isActive }) => ({
                backgroundColor: isActive ? currentColor : "",
              })}
              className={({ isActive }) => (isActive ? activeLink : normalLink)}
            >
              <FiLogOut />
              <span className="capitalize ">Cerrar sesión</span>
            </NavLink>
          </div>
        </>
      )}
    </div>
  );
};

const mapDispatchToprops = {
  logoutRequest,
};

const mapStateToProps = (state) => {
  return {
    permission: (state.permission || [])
      .filter((data) => data.modulosAcciones?.id_acciones === 1)
      .map((item) => item.modulosAcciones?.id_modulos),
  };
};

export default connect(mapStateToProps, mapDispatchToprops)(Sidebar);
